import React from "react";
import "./PrivacyPolicy.css";
import PrivacyPolicyHeader from "./PrivacyPolicyHeader";

const PrivacyPolicy = () => {
  const policyData = [
    {
      title: "Data Collection and Usage",
      description:
        "We collect personal data from job seekers and employers to facilitate the recruitment process. This includes contact details, employment history, and other relevant information.",
    },
    {
      title: "Confidentiality and Security",
      description:
        "Your information is protected and only shared with potential employers with your consent. We employ robust security measures to safeguard your data.",
    },
    {
      title: "Third-Party Disclosure",
      description:
        "We do not share your information with third parties without your permission, except as required by law or to protect our rights.",
    },
    {
      title: "Consent and Transparency",
      description:
        "By using our services, you consent to our privacy policy and data practices. We maintain transparency about how your data is collected and used.",
    },
    {
      title: "User Rights and Access",
      description:
        "You have the right to access, update, or delete your personal information at any time by contacting us through our support channels.",
    },
    {
      title: "Cookies and Tracking",
      description:
        "Our website uses cookies to enhance user experience and analyze site traffic. You can adjust your browser settings to manage cookie preferences.",
    },
    {
      title: "Data Retention Policy",
      description:
        "We retain personal data only as long as necessary to fulfill the purposes for which it was collected or as required by law.",
    },
    {
      title: "Policy Updates and Changes",
      description:
        "Our privacy policy may be updated periodically. We notify users of significant changes via email or website notifications.",
    },
    {
      title: "Contact Information",
      description:
        "For questions or concerns regarding our privacy policy, please contact us at support@srimathimanpower.com.",
    },
    {
      title: "Governing Law and Jurisdiction",
      description:
        "This privacy policy is governed by the laws of India, and any disputes arising from it are subject to the jurisdiction of Indian courts.",
    },
  ];

  return (
    <>
      <PrivacyPolicyHeader />
      <div className="privacypolicy-container container">
        <h1 className="privacypolicy-title">Privacy Policy</h1>
        {policyData.map((item, index) => (
          <div key={index} className="privacypolicy-section">
            <h2 className="privacypolicy-subtitle">{item.title}</h2>
            <p className="privacypolicy-description">{item.description}</p>
          </div>
        ))}
      </div>
    </>
  );
};

export default PrivacyPolicy;
